import React from "react";
// import "../Styles/Selector.scss"

const Selector = (props) => {
  return (
    <>
        <div className= {"body2 " + props.a1}>
            <h3 cid="name">{props.name}</h3>
        </div>
    </>
  );
};

export default Selector;
